import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import Image from "components/ui/image"
import { cn } from "styles/utils"

export const CardProductImageContainer = ({
  className = "",
  outOfStock,
  ...props
}) => (
  <div
    className={cn(
      "relative h-full",
      outOfStock &&
        "after:absolute after:left-0 after:top-0 after:h-full after:w-full after:bg-black after:opacity-10",
      className
    )}
    {...props}
  />
)
CardProductImageContainer.propTypes = {
  className: PropTypes.string,
  outOfStock: PropTypes.bool,
}

export const CardProductImage = ({ className = "", ...props }) => (
  <Image
    className={cn(
      "desktop:h-(--desktop-height) desktop:w-(--desktop-width)",
      className
    )}
    height="120"
    style={{
      "--desktop-height": "128px",
      "--desktop-width": "128px",
    }}
    width="120"
    {...props}
  />
)
CardProductImage.propTypes = {
  className: PropTypes.string,
}

export const CardRemove = ({ className = "", disabled, ...props }) => (
  <Button
    className={cn(
      "z-1 active:bg-grey-10 border-grey-65 text-grey-65 text-16 absolute -left-12 -top-12 block size-28 items-center justify-center rounded-full border bg-white text-center leading-none",
      disabled ? "opacity-50" : "opacity-100",
      className
    )}
    {...props}
  />
)
CardRemove.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
}
export const Card = ({ className = "", ...props }) => (
  <div
    className={cn(
      "pt-15 relative rounded-xl bg-white px-10 pb-10 shadow-lg",
      className
    )}
    {...props}
  />
)
Card.propTypes = {
  className: PropTypes.string,
}

export const CardTitle = ({ className = "", ...props }) => (
  <Link
    className={cn(
      "border-b-grey-5 text-16 mx-15 leading-18 mb-12 block overflow-hidden text-ellipsis whitespace-nowrap border-b",
      className
    )}
    {...props}
  />
)
CardTitle.propTypes = {
  className: PropTypes.string,
}

export const CardItemInfo = ({ className = "", ...props }) => (
  <div className={cn("flex flex-col flex-nowrap", className)} {...props} />
)
CardItemInfo.propTypes = {
  className: PropTypes.string,
}

export const ItemTitle = ({ className = "", ...props }) => (
  <p
    className={cn(
      "text-14 tablet:text-16 tracking-half mb-16 text-black",
      className
    )}
    {...props}
  />
)
ItemTitle.propTypes = {
  className: PropTypes.string,
}
export const ItemAction = ({ className = "", ...props }) => (
  <Button
    className={cn(
      "text-link text-14 hover:text-link block font-light",
      className
    )}
    text
    variant="secondary"
    {...props}
  />
)
ItemAction.propTypes = {
  className: PropTypes.string,
}

export const OutOfStockLabel = ({ className = "", ...props }) => (
  <div
    className={cn(
      "text-12 h-22 leading-22 z-1 absolute bottom-0 w-full bg-black text-center font-bold text-white",
      className
    )}
    {...props}
  />
)
OutOfStockLabel.propTypes = {
  className: PropTypes.string,
}
export const CardItem = ({ className = "", selected, ...props }) => (
  <Button
    className={cn(
      "focus:border-primary focus:outline-hidden shrink- block min-w-0 grow-0 basis-[30vw] rounded-lg border-2 border-transparent p-10 text-center",
      selected &&
        "after:content-(--checkmark-icon) border-selected after:size-22 after:scale-80 relative after:absolute after:-bottom-12 after:left-1/2 after:block after:-translate-x-1/2",
      className
    )}
    text
    {...props}
  />
)
CardItem.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
}
